/**
 * What a staff sign-in leaves on this device, removed when it ends — by the
 * sign-out button, the idle timeout, or an expired session.
 *
 * The cached pages are QueryProvider's to clear; this is the rest:
 *   - recent items: the athletes, deals and contacts opened, by name;
 *   - preferences: the local copy (the server keeps them, and they are
 *     restored at the next sign-in);
 *   - a portal token older builds wrote and never cleared;
 *   - an open "See what they see" preview, which carries the agent's token.
 * Filter presets and the demo-data flag hold nothing about anyone, and stay.
 */

import { exitPreview, isPreview } from '../api/clientPortal/previewMode'

const PERSONAL_KEYS = ['dealpoint_recent_items', 'dealpoint_preferences', 'reppr_portal_pb_auth']

export function clearSignedInDeviceData(): void {
  for (const key of PERSONAL_KEYS) {
    try { localStorage.removeItem(key) } catch (err) { console.error(`[sign-out] could not remove ${key} from this device:`, err) }
  }
  if (isPreview()) exitPreview()
}
